import { schema } from "normalizr";

export const publicProfile = new schema.Entity("publicProfiles");
export const publicProfileList = new schema.Array(publicProfile);
